export function convertQueryObjectToQueryString(queryObj: {
  [key: string]: any;
}): string {
  const params = new URLSearchParams();

  // Iterate over the query object and populate the URLSearchParams
  for (const key in queryObj) {
    if (Object.prototype.hasOwnProperty.call(queryObj, key)) {
      const value = queryObj[key];

      // Handle case where value is an array
      if (Array.isArray(value)) {
        value.forEach((item) => params.append(key, item));
      } else {
        params.append(key, value.toString());
      }
    }
  }

  // Convert to string and return
  return params.toString();
}
